<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" sm="12" xs="12" class="float-right" @click="mtdBack">
        <button @click="mtdBack" type="button" class="btn btn-sm text-white float-right" style="background: #E46666">
          <i class="fas fa-hand-point-left"></i> Ir a Inicio
        </button>
      </CCol>
    </CRow>
    <CRow id="div_conte2">
      <div id="div_conte" class="col-md-10 mx-auto">
        <div class="bg-secondary text-white bg-opacity-10">
          <div class="text-center py-4 px-5" id="scroll-div">
            <div v-for="(buttonGroup, index) in groupedButtons" :key="index" class="row">
              <button v-for="(button, idx) in buttonGroup" :key="idx" class="div-button col m-2 p-2 text-white"
                @click="changePage(button.page)">
                {{ button.label }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </CRow>

  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "home",
  created() {
    this.showBead();
  },
  data() {
    return {
      buttons: [
        { label: "REPORTES DE COMPRA", page: "purchase_reports" },
        { label: "REPORTES DE VENTA", page: "sale_reports" },
        { label: "REPORTES DE UTILIDADES", page: "utilities" },
        { label: "REPORTES DE CITAS", page: "citas" },
        // { label: "REPORTES DE ASISTENCIAS", page: "asistencia_reports_demo" },
        { label: "REPORTES DE ASISTENCIAS", page: "asistencia_reports_katalynas" },
        { label: "REPORTES DE ENCARGADOS", page: "encargado_reports" },
        { label: "REPORTES DE CAJA", page: "box_reports" },
        { label: "REPORTES DE CLIENTES", page: "clients_reports" },
        { label: "REPORTES DE DOCUMENTOS", page: "documents_reports" },
        { label: "REPORTE DE SERVICIOS NO REGISTRADOS", page: "unregistered_services_reports" },
        { label: "REPORTE DE ASISTENCIAS (RANGOS)", page: "asistencia_reports_rank" },
        { label: "CRM CLIENTES", page: "crm_clients_quotes" },
        { label: "REPORTE DE PAGOS", page: "payment_report" },
      ],
      verificBead: false,
    };
  },
  computed: {
    filteredButtons() {
      const userRol = this.$store.getters.get_rol.id;
      const companyId = this.$store.getters.get_company.id;

      const excludedForCompany11 = [
        "asistencia_reports",
        "unregistered_services_reports",
        "asistencia_reports_rank",
        "crm_clients_quotes",
        "encargado_reports",
        "utilities",
        "asistencia_reports_demo",
        "asistencia_reports_katalynas",
        "payment_report" 
      ];

      if (userRol === 4 && companyId === 10) {
        return this.buttons;
      } else if (userRol === 4 && companyId === 11) {
        return this.buttons.filter(
          (button) => !excludedForCompany11.includes(button.page)
        );
      } else if (userRol === 2 && companyId === 10) {
        return this.buttons.filter(button =>
          ["clients_reports", "encargado_reports", "crm_clients_quotes", "utilities"].includes(button.page)
        );
      } else {
        return this.buttons.filter(button => button.page === "clients_reports");
      }
    },
    groupedButtons() {
      const groups = [];
      for (let i = 0; i < this.filteredButtons.length; i += 4) {
        groups.push(this.filteredButtons.slice(i, i + 4));
      }
      return groups;
    }
  },
  methods: {
    ...mapActions(["get", "post"]),
    changePage: function (page) {
      if (page == "sale" && !this.verificBead) {
        Swal.fire({
          title: "No hay caja aperturada",
          icon: "warning",
        });
      } else {
        this.$emit("changePage", page);
      }
    },
    hasRoles(roles) {
      return roles.some((role) => this.userRoles.includes(role));
    },
    showBead() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/showBead/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.verificBead = response.data ? true : false;
            // this.bead = this.verificBead == true ? response.data : {};
          }
        })
        .catch((errors) => { });
    },
    mtdBack() {
      this.$emit('setView', 'home')
    },
  },
};
</script>

<style scoped>
#div_conte {
  border: 1.5px solid #00003a;
  padding: 0;
  margin: 40px 0;
}

.div-button {
  background: #00003a;
  border-radius: 15px;
  border: none;
}

#scroll-div {
  height: auto;
  overflow-y: scroll;
}

#scroll-div>div>button {
  height: 65px;
}

@media (max-width: 1320px) {
  #div_conte {
    border: 1.5px solid #00003a;
    padding: 0;
    margin: 60px 0;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {

  #div_conte {
    border: 1.5px solid #00003a;
    padding: 0;
    margin: 100px 0;
  }

  #scroll-div {
    height: 518px;
  }
}

@media (max-width: 768px) {
  #scroll-div>div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #div_conte2 {
    padding-left: 30px;
    padding-right: 30px;
  }

  #scroll-div>div>button {
    height: 44px;
    width: 100%;
    margin: 5px 0;
  }

  .container {
    font-size: 11px;
  }

  #scroll-div {
    height: 450px;
  }
}

@media (max-width: 415px) {
  #scroll-div>div>button {
    height: 40px;
    font-size: 12px;
  }
}
</style>